export default __webpack_public_path__ + "static/media/leadlag.e2214f61.svg";